import React from 'react';
import { View } from 'react-native';
import { Text } from '@shared/components/text';
import { dynamicTranslations } from '@shared/utils/dynamicTranslation';
import LoadingSpinner from '@md-design-system/Layout/LoadingSpinner';
import { Button } from '@md-design-system/Button/Button';

interface LoadingProps {
  message?: string;
  onRetry?: () => void;
}

export const Loading = ({ message, onRetry }: LoadingProps) => {
  const { t } = dynamicTranslations();
  return (
    <View className="flex-1 justify-center items-center gap-6 px-6">
      {!onRetry && <LoadingSpinner size="large" color="primary" />}
      <Text className="mt-8 font-medium text-base text-center">
        {message || t('commons.loading.generic')}
      </Text>
      {onRetry && (
        <Button variant="primary" onPress={onRetry}>
          {t('buttons.retry')}
        </Button>
      )}
    </View>
  );
};
